module.exports = __webpack_public_path__ + "static/media/Carousel Image 1.e9017010.png";